import { useNavigate } from 'react-router-dom';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px',
    }}>
      {/* Header */}
      <header style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px 0',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <h1 style={{ color: 'white', margin: 0, fontSize: '28px' }}>VirtueSign</h1>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <button
            onClick={() => navigate('/features')}
            style={{
              background: 'transparent',
              color: 'white',
              padding: '8px 16px',
              border: 'none',
              fontWeight: '600',
              fontSize: '16px',
              cursor: 'pointer',
              opacity: 0.9,
            }}
            onMouseOver={(e) => e.currentTarget.style.opacity = '1'}
            onMouseOut={(e) => e.currentTarget.style.opacity = '0.9'}
          >
            Features
          </button>
          <button
            onClick={() => navigate('/support')}
            style={{
              background: 'transparent',
              color: 'white',
              padding: '8px 16px',
              border: 'none',
              fontWeight: '600',
              fontSize: '16px',
              cursor: 'pointer',
              opacity: 0.9,
            }}
            onMouseOver={(e) => e.currentTarget.style.opacity = '1'}
            onMouseOut={(e) => e.currentTarget.style.opacity = '0.9'}
          >
            Support
          </button>
          <button
            onClick={() => navigate('/login')}
            style={{
              background: 'white',
              color: '#667eea',
              padding: '12px 28px',
              border: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '16px',
              cursor: 'pointer',
              transition: 'transform 0.2s',
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            Sign In
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <main style={{
        maxWidth: '1200px',
        margin: '80px auto',
        textAlign: 'center',
        color: 'white',
      }}>
        <h2 style={{
          fontSize: '56px',
          marginBottom: '20px',
          fontWeight: '700',
          lineHeight: '1.2',
        }}>
          Email Signatures Made Simple
        </h2>
        
        <p style={{
          fontSize: '22px',
          marginBottom: '50px',
          opacity: 0.95,
          maxWidth: '700px',
          margin: '0 auto 50px',
        }}>
          Centralized email signature management for Microsoft 365. 
          Deploy branded signatures across your organization in minutes.
        </p>

        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', marginBottom: '80px' }}>
          <button
            onClick={() => navigate('/login')}
            style={{
              background: 'white',
              color: '#667eea',
              padding: '18px 40px',
              border: 'none',
              borderRadius: '10px',
              fontWeight: '700',
              fontSize: '18px',
              cursor: 'pointer',
              boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
              transition: 'transform 0.2s',
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            🚀 Get Started
          </button>
          
          <button
            onClick={() => navigate('/login')}
            style={{
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              padding: '18px 40px',
              border: '2px solid white',
              borderRadius: '10px',
              fontWeight: '600',
              fontSize: '18px',
              cursor: 'pointer',
              backdropFilter: 'blur(10px)',
            }}
          >
            Sign In to Dashboard
          </button>
        </div>

        {/* Features */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '30px',
          marginTop: '80px',
        }}>
          <FeatureCard
            icon="⚡"
            title="Quick Setup"
            description="One-click admin consent. Connect your Microsoft 365 organization in seconds."
          />
          <FeatureCard
            icon="🎨"
            title="Visual Builder"
            description="Design professional email signatures with drag-and-drop. No HTML knowledge required."
          />
          <FeatureCard
            icon="🏢"
            title="Centralized Control"
            description="Manage all email signatures from one dashboard with role-based access."
          />
          <FeatureCard
            icon="🔒"
            title="Secure by Design"
            description="Encrypted credentials, secure authentication, and compliance with Microsoft security standards."
          />
          <FeatureCard
            icon="📊"
            title="Group Policies"
            description="Assign signatures by Azure AD groups with priority rules. Deploy automatically."
          />
          <FeatureCard
            icon="🔄"
            title="Auto Sync"
            description="Automatic user and group synchronization from Microsoft Graph API."
          />
        </div>

        {/* Beta Launch Offer Banner */}
        <div style={{ marginTop: '100px', textAlign: 'center' }}>
          <div style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.25), rgba(255,255,255,0.15))',
            backdropFilter: 'blur(10px)',
            padding: '25px 40px',
            borderRadius: '12px',
            border: '2px solid rgba(255,255,255,0.4)',
            maxWidth: '700px',
            margin: '0 auto 50px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          }}>
            <p style={{ fontSize: '22px', fontWeight: '700', marginBottom: '8px' }}>
              Beta Launch Offer
            </p>
            <p style={{ fontSize: '18px', opacity: 0.95, lineHeight: '1.6' }}>
              All trials are <strong>completely free until January 1st, 2026</strong>. Start today and enjoy full access at no cost!
            </p>
          </div>
        </div>

        {/* Template Builder Demo */}
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <h3 style={{ fontSize: '42px', marginBottom: '20px', fontWeight: '700' }}>
            Try the Template Builder
          </h3>
          <p style={{ fontSize: '20px', opacity: 0.95, marginBottom: '40px', maxWidth: '800px', margin: '0 auto 40px' }}>
            Experience the actual template builder with sample data. No login required!
          </p>
          <button
            onClick={() => navigate('/demo')}
            style={{
              background: 'white',
              color: '#667eea',
              padding: '20px 50px',
              border: 'none',
              borderRadius: '12px',
              fontWeight: '700',
              fontSize: '20px',
              cursor: 'pointer',
              boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
              transition: 'transform 0.2s',
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            Try Interactive Demo
          </button>
          <p style={{ fontSize: '14px', opacity: 0.85, marginTop: '20px' }}>
            No login required - play with the actual builder
          </p>
        </div>

        {/* How It Works */}
        <div style={{ marginTop: '100px', textAlign: 'left', maxWidth: '900px', margin: '100px auto 0' }}>
          <h3 style={{ fontSize: '36px', marginBottom: '40px', textAlign: 'center' }}>
            How It Works
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
            <Step number="1" title="Grant Admin Consent" description="Click 'Get Started' and authorize VirtueSign to access your Microsoft 365 organization." />
            <Step number="2" title="Sync Users & Groups" description="VirtueSign automatically syncs users and groups from your organization." />
            <Step number="3" title="Design Signatures" description="Use the visual builder to create branded email signatures with logos and social links." />
            <Step number="4" title="Assign & Deploy" description="Assign templates to groups, then deploy signatures to mailboxes with one click." />
          </div>
        </div>

        {/* Pricing Section */}
        <PricingSection />
      </main>

      {/* Footer */}
      <footer style={{
        maxWidth: '1200px',
        margin: '100px auto 0',
        padding: '40px 0',
        borderTop: '1px solid rgba(255,255,255,0.2)',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.8)',
      }}>
        <p>© {new Date().getFullYear()} VirtueSign by Virtue ApS - Email Signature Management</p>
        <div style={{ marginTop: '20px', display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="/features" style={{ color: 'white', textDecoration: 'none' }}>Features</a>
          <a href="/support" style={{ color: 'white', textDecoration: 'none' }}>Support</a>
          <a href="/privacy" style={{ color: 'white', textDecoration: 'none' }}>Privacy Policy</a>
          <a href="/terms" style={{ color: 'white', textDecoration: 'none' }}>Terms of Service</a>
        </div>
      </footer>
    </div>
  );
}

function FeatureCard({ icon, title, description }: { icon: string; title: string; description: string }) {
  return (
    <div style={{
      background: 'rgba(255,255,255,0.1)',
      backdropFilter: 'blur(10px)',
      padding: '30px',
      borderRadius: '12px',
      border: '1px solid rgba(255,255,255,0.2)',
      textAlign: 'left',
    }}>
      <div style={{ fontSize: '40px', marginBottom: '15px' }}>{icon}</div>
      <h4 style={{ fontSize: '20px', marginBottom: '10px', fontWeight: '600' }}>{title}</h4>
      <p style={{ fontSize: '15px', opacity: 0.9, lineHeight: '1.5' }}>{description}</p>
    </div>
  );
}

function Step({ number, title, description }: { number: string; title: string; description: string }) {
  return (
    <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
      <div style={{
        background: 'white',
        color: '#667eea',
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        fontWeight: '700',
        flexShrink: 0,
      }}>
        {number}
      </div>
      <div>
        <h5 style={{ fontSize: '22px', marginBottom: '8px', fontWeight: '600' }}>{title}</h5>
        <p style={{ fontSize: '16px', opacity: 0.9, lineHeight: '1.5' }}>{description}</p>
      </div>
    </div>
  );
}

function PricingSection() {
  const navigate = useNavigate();

  return (
    <div style={{ marginTop: '100px', textAlign: 'center' }}>
      <h3 style={{ fontSize: '42px', marginBottom: '20px', fontWeight: '700' }}>
        Simple, Transparent Pricing
      </h3>
      <p style={{ fontSize: '20px', opacity: 0.95, marginBottom: '50px', maxWidth: '800px', margin: '0 auto 50px' }}>
        Pay only for what you use. No hidden fees, no surprises.
      </p>

      {/* Pricing Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '30px',
        maxWidth: '900px',
        margin: '0 auto 50px',
      }}>
        <div style={{
          background: 'rgba(255,255,255,0.15)',
          backdropFilter: 'blur(10px)',
          padding: '40px 30px',
          borderRadius: '16px',
          border: '1px solid rgba(255,255,255,0.3)',
          textAlign: 'center',
        }}>
          <h4 style={{ fontSize: '24px', marginBottom: '15px', fontWeight: '600' }}>1-100 Users</h4>
          <div style={{ fontSize: '48px', fontWeight: '700', marginBottom: '10px' }}>
            100 <span style={{ fontSize: '24px', fontWeight: '400' }}>DKK</span>
          </div>
          <p style={{ opacity: 0.9, marginBottom: '20px' }}>per month</p>
          <p style={{ fontSize: '16px', opacity: 0.85 }}>Flat rate pricing</p>
        </div>

        <div style={{
          background: 'rgba(255,255,255,0.15)',
          backdropFilter: 'blur(10px)',
          padding: '40px 30px',
          borderRadius: '16px',
          border: '1px solid rgba(255,255,255,0.3)',
          textAlign: 'center',
        }}>
          <h4 style={{ fontSize: '24px', marginBottom: '15px', fontWeight: '600' }}>101+ Users</h4>
          <div style={{ fontSize: '48px', fontWeight: '700', marginBottom: '10px' }}>
            1 <span style={{ fontSize: '24px', fontWeight: '400' }}>DKK</span>
          </div>
          <p style={{ opacity: 0.9, marginBottom: '20px' }}>per user / month</p>
          <p style={{ fontSize: '16px', opacity: 0.85 }}>Pay as you grow</p>
          <p style={{ fontSize: '14px', opacity: 0.75, marginTop: '5px' }}>Simple per-user pricing</p>
        </div>
      </div>

      {/* Pricing Explanation */}
      <div style={{
        background: 'rgba(255,255,255,0.1)',
        backdropFilter: 'blur(10px)',
        padding: '40px',
        borderRadius: '16px',
        border: '1px solid rgba(255,255,255,0.2)',
        maxWidth: '700px',
        margin: '0 auto 40px',
        textAlign: 'left',
      }}>
        <h4 style={{ fontSize: '24px', marginBottom: '25px', fontWeight: '600', textAlign: 'center' }}>How Pricing Works</h4>
        <div style={{ fontSize: '16px', lineHeight: '1.8', opacity: 0.95 }}>
          <p style={{ marginBottom: '20px' }}>
            <strong>For organizations with 1-100 users:</strong> Pay a simple flat rate of <strong>100 DKK per month</strong>.
          </p>
          <p style={{ marginBottom: '20px' }}>
            <strong>For organizations with 101+ users:</strong> Pay <strong>1 DKK per user per month</strong>. If you have 250 users, you pay 250 DKK per month.
          </p>
          <p style={{ marginBottom: '0', opacity: 0.9, fontSize: '15px' }}>
            Pricing scales with your organization. Add or remove users anytime - you only pay for active licensed users each month.
          </p>
        </div>
      </div>

      {/* Features List */}
      <div style={{ marginBottom: '40px' }}>
        <p style={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px' }}>All plans include:</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px', fontSize: '16px', opacity: 0.9 }}>
          <span>✓ 14-day free trial</span>
          <span>✓ All features included</span>
          <span>✓ Unlimited templates</span>
          <span>✓ Cancel anytime</span>
        </div>
      </div>

      <button
        onClick={() => navigate('/login')}
        style={{
          background: 'white',
          color: '#667eea',
          padding: '18px 50px',
          border: 'none',
          borderRadius: '10px',
          fontWeight: '700',
          fontSize: '18px',
          cursor: 'pointer',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          transition: 'transform 0.2s',
        }}
        onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
        onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
      >
        Start Free Trial
      </button>
    </div>
  );
}
